// !--- Trryst Confidential. Please do not share or distribute without approval from Trryst (CSuite Ltd.)
import * as React from "react";
import SimpleNotificationCard from "blocks/views/Notifications/foundations/SimpleNotificationCard";
import { getS3ImageWrapper } from "@app21/core";

const DocketDeletedSuite = ({ notification, viewContext, index }) => {
  const { payload } = notification;
  let dummyPicture = `images/suitestockimages/suiteImage-5.jpg`;

  const data = {
    message: `Breakout meeting - ${
      payload?.removedDocketFullName
    } has been deleted from ${payload?.suiteFullName || "Suite"}`,
    avatar: getS3ImageWrapper(payload?.removedByImage || dummyPicture),
    subHeader: notification.createdAt,
  };
  return (
    <SimpleNotificationCard
      data={data}
      notification={notification}
      viewContext={viewContext}
      index={index}
    />
  );
};

export default DocketDeletedSuite;
